import { createApp, nextTick } from "vue";
import Utils from "../../../modules/utils/utils-js/theme/js/utils/Utils";
import { Site } from "../Site";
import Program from "../utils/Program";
import RegisterBox from "../widgets/RegisterBox";
import { mapStores } from "pinia";
import { sympomedStore } from "../SympomedStorage";
import ConsentDialog from "../components/ConsentDialog";

interface BoxOptions {
    id: number;
    skiptranslate: boolean;
    consent_profession?: boolean;
}

export default class {
    public static widgets = {
        RegisterBox,
    }

    public static $live: JQuery;
    public static $btn_bigmode: JQuery;

    public static toggleBigMode(): void {
        const cls = 'wseventlive--bigmode';
        const bigmode = !this.$live.hasClass(cls);

        this.$live.toggleClass(cls, bigmode);

        const text_expand = this.$btn_bigmode.data('expand');
        const text_shrink = this.$btn_bigmode.data('shrink');

        if (bigmode) {
            this.$btn_bigmode.html(`
                <i class="fa fa-compress-arrows-alt"></i> ${text_shrink}
            `);
        } else {
            this.$btn_bigmode.html(`
                <i class="fa fa-expand-arrows-alt"></i> ${text_expand}
            `);
        }
    }

    private static initEventMenu(): void {
        let $logo = $('.eventheader__logo');
        let $links = $('.eventmenu .eventmenu__link');
        let $links_all = $('.eventmenu__link');
        let anchors = [];

        $links.each((ix, el) => {
            let name = el.getAttribute('href').substr(1);
            let $anchor: JQuery = $('#' + name);

            if (!$anchor.length) {
                $anchor = $('a[name="' + name + '"]');
            }

            anchors.push({
                name: name,
                $link: $(el),
                $anchor: $anchor
            });
        });

        anchors.reverse();

        $links_all.click(function (e) {
            e.preventDefault();

            const href = $(this).attr('href');

            Utils.scrollToName(href, true, href == '#register');
        });

        $logo.on('click', (e) => {
            e.preventDefault();

            Utils.scrollTo(0);
        });

        function updateMenu(): void {
            let top = $(this).scrollTop();

            $links.removeClass('eventmenu__link--selected');

            $.each(anchors, (k, v) => {
                let atop = v.$anchor.offset().top;

                if (atop - 200 < top) {
                    v.$link.addClass('eventmenu__link--selected');

                    return false;
                }
            });
        }

        $(window).on('scroll', updateMenu);

        updateMenu();
    }

    private static initTabs($el: JQuery, wseventid: number): void {
        const lang = $('html').prop('lang');

        const $tabnav = $('.eventtabs__nav-item', $el);
        const $tabs = $('.eventtabs__tab', $el);

        const apps = [];

        $tabs.each((ix, el) => {
            const $tab = $(el);

            if ($tab.hasClass('inited')) {
                return;
            }

            $tab.addClass('inited');

            const $tabapp = $('.eventtabs__tab-app', $tab);
            const $tabbutton = $tabnav.eq(ix);

            const options: BoxOptions = $tab.data('options');

            const app = createApp({
                components: {
                    ConsentDialog,
                },

                template: `
                    <ConsentDialog v-if="show" question="Oświadczam, że jestem osobą uprawnioną do wystawiania recept oraz posiadam numer prawa wykonywania zawodu." :accepted="accepted" @update:accepted="sympomedStore.consents.profession = $event" :cancel_html="options.consent_profession?.cancel_content">
                        <div v-if="html" :class="{ skiptranslate: options.skiptranslate }" v-html="html" ref="hc"></div>
                    </ConsentDialog>
                `,

                created() {
                    if (!this.accepted) {
                        $tab.toggleClass('eventtabs__tab--notaccepted');
                    }
                },

                data() {
                    return {
                        options: options,
                        html: null,

                        loaded: false,
                        show: false,
                    };
                },

                watch: {
                    accepted(val: boolean) {
                        $tab.toggleClass('eventtabs__tab--notaccepted', !val);
                    },

                    show(val: boolean) {
                        $tabbutton.toggleClass('eventtabs__nav-item--selected', val);

                        if (val) {
                            this.loadHtml();
                        }
                    },
                },

                computed: {
                    ...mapStores(sympomedStore),

                    accepted() {
                        if (this.options.consent_profession?.active) {
                            return this.sympomedStore.consents.profession;
                        } else {
                            return true;
                        }
                    },
                },

                methods: {
                    async loadHtml() {
                        if (!this.loaded) {
                            const url = `/${lang}/wsevents/${wseventid}/tab/${this.options.id}`;

                            try {
                                this.html = await $.get(url).promise();

                                nextTick(() => {
                                    $('.wseventlive__video', this.$refs.hc).on('contextmenu', (e) => {
                                        e.preventDefault();
                                    });
                                });

                                this.loaded = true;
                            } catch (e) {
                                this.html = 'Nie udało wczytać się zakładki.';
                            }
                        }
                    },
                },
            });

            app.use(Site.pinia);

            const vm = app.mount($tabapp[0]);
            apps.push(vm);

            $tabbutton.on('click', () => {
                const others = apps.filter(v => v != this);
                others.forEach(v => v.show = false);

                (<any> vm).show = true;
            });

        });

        if (apps.length) {
            apps[0].show = true;
        }
    }

    private static initLiveTabs(): void {
        const $lives = $('.wseventlive__live');

        if ($lives.length == 1) {
            $lives.show();
        } else {
            const $tabs = $('.wseventlive__tabs-item');

            const selFunc = (ix: number) => {
                const $tab = $tabs.eq(ix);
                const $live = $lives.eq(ix);

                $tabs.removeClass('wseventlive__tabs-item--selected')
                $tab.addClass('wseventlive__tabs-item--selected')
                $lives.hide();
                $live.show();
            };

            $tabs.each((ix, el) => {
                const $tab = $(el);

                $tab.on('click', () => {
                    selFunc($tab.index());
                });
            });

            selFunc(0);
        }

        $('.wseventlive__video', $lives).on('contextmenu', (e) => {
            e.preventDefault();
        });
    }

    private static initCounter($counter: JQuery): void {
        const time = $counter.data('time');
        const start = Math.round(new Date().getTime()) / 1000;

        let timer = null;

        function format(v: number): string {
            return v.toString().length == 1 ? '0' + v : v.toString();
        }

        function update() {
            const pad = Math.round(new Date().getTime()) / 1000 - start;
            let t = time - pad;

            if (t < 0) {
                clearTimeout(timer);
                timer = null;

                return;
            }

            const s = Math.floor(t % 60);
            const m = Math.floor(t / 60) % 60;
            const h = Math.floor(t / 60 / 60) % 24;
            const d = Math.floor(t / 60 / 60 / 24);

            $('.eventcounter__item--s .eventcounter__value', $counter).text(format(s));
            $('.eventcounter__item--m .eventcounter__value', $counter).text(format(m));
            $('.eventcounter__item--h .eventcounter__value', $counter).text(format(h));
            $('.eventcounter__item--d .eventcounter__value', $counter).text(d);
        }

        if ($counter.length) {
            timer = window.setInterval(() => {
                update();
            }, 333);

            update();
        }
    }

    private static initMovie(): void {
        const $movie = $('.vevent__header-image--movie');

        if (!$movie.length) {
            return;
        }

        const $video = $('video', $movie);
        const video = $video[0] as HTMLVideoElement;
        const $mute = $('button', $movie);

        video.addEventListener('volumechange', (e) => {
            const $i = $('i', $mute);
            $i.toggleClass('fa-volume-mute', video.muted);
            $i.toggleClass('fa-volume-up', !video.muted);
        });

        $mute.on('click', () => {
            video.muted = !video.muted;
        });

        $video.on('click', (e) => {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });

        video.play();
    }

    public static initEventTabs(): void {
        const $tabs = $('.eventtabs');
        const wseventid: number = $tabs.data('id');

        $tabs.each((ix, el) => {
            const $el = $(el);

            this.initTabs($el, wseventid);
        });
    }

    public static init(): void {
        $(() => {
            this.$live = $('.wseventlive');

            this.$btn_bigmode = $('.wseventlive__bigmode-button');

            this.$btn_bigmode.on('click', (e) => {
                this.toggleBigMode();
            });

            this.initMovie();
            this.initEventMenu();

            new Program();

            const $counter = $('.eventcounter');
            this.initCounter($counter);

            this.initEventTabs();
            this.initLiveTabs();
        });
    }
}
